/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectExamAnswerid200,
  GetApiV1ExamCorrectExamAnswerid400,
  GetApiV1ExamCorrectExamAnswerid401,
  GetApiV1ExamCorrectExamAnswerid500,
  GetApiV1ExamCorrectExamAnsweridPathParams,
  GetApiV1ExamCorrectExamAnsweridQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectExamAnswerid.ts";
import { examItemAnswerTextCorrectionViewModelSchema } from "../examItemAnswerTextCorrectionViewModelSchema.ts";

export const getApiV1ExamCorrectExamAnsweridPathParamsSchema = z.object({
  answerId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamCorrectExamAnsweridPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectExamAnswerid200Schema = z.lazy(
  () => examItemAnswerTextCorrectionViewModelSchema,
) as unknown as ToZod<GetApiV1ExamCorrectExamAnswerid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectExamAnswerid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectExamAnswerid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectExamAnswerid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectExamAnswerid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectExamAnswerid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectExamAnswerid500>;

export const getApiV1ExamCorrectExamAnsweridQueryResponseSchema = z.lazy(
  () => getApiV1ExamCorrectExamAnswerid200Schema,
) as unknown as ToZod<GetApiV1ExamCorrectExamAnsweridQueryResponse>;
